import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components/Button/Button';
import { LocationStepFooter as messages } from './messages';

export const LocationStepFooter: VFC = () => (
  <Button key="submit" block form="locationStepForm" htmlType="submit" type="primary">
    <FormattedMessage {...messages.next} />
  </Button>
);
